import { render } from "./FormSignature.vue?vue&type=template&id=3f9dd964"
import script from "./FormSignature.vue?vue&type=script&lang=js"
export * from "./FormSignature.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SanttuLehtinen\\Projektit\\vetera\\vetera-management\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__